<template>
  <full-page title="Open Tables">
    <AllTables/>
  </full-page>
</template>

<script>
import AllTables from "@/components/point-of-sale/table/AllTables";
import FullPage from "@/components/layout/utils/FullPage";

export default {
  name: "AllTablesView",
  components: {FullPage, AllTables},
  beforeRouteLeave(to, from, next){
    // Do NOT clear the open table name when navigating to POS; it is needed there
    if (to && to.name && to.name.toLowerCase() !== 'pos') {
      this.$store.commit("setOpenTableName", null)
    }
    return next();
  }
}
</script>